export const getRuntimeEnvironment = (
  hostname: string | undefined = window.location.hostname,
): "production" | "staging" => {
  if (
    hostname === "iwoca.co.uk" ||
    hostname?.endsWith(".iwoca.co.uk") ||
    hostname === "iwoca.de" ||
    hostname?.endsWith(".iwoca.de")
  ) {
    return "production";
  }

  return "staging";
};
